import React from "react"
import styled from "styled-components"
import MVVideoPlayer from "../MVVideoPlayer"
import LazyLoad from "react-lazyload"
import YoutubPlayButton from "../Icons/YoutubPlayButton"

const Container = styled.div`
  width: 100%;
  height: auto;
  text-align: center;
  @media (max-width: 768px) {
    height: auto;
  }
`

const InnerContainer = styled.div`
  border-radius: 10px;
  box-shadow: 0px 0px 4px 0px #bbbdb7;
  position: relative;
`

const CallToAct = styled.label`
  position: absolute;
  top: calc(50% - 30px);
  left: calc(50% - 30px);
  &:hover {
    cursor: pointer;
  }
`

const VideoBlock = (props) => {
  const { video, action } = props

  return (
    <LazyLoad offset={200} height={330}>
      <Container>
        <InnerContainer>
          <MVVideoPlayer source={video} type="video/youtube" />
          <CallToAct onClick={() => action()}>
            <YoutubPlayButton />
          </CallToAct>
        </InnerContainer>
      </Container>
    </LazyLoad>
  )
}

export default VideoBlock
